import { Component } from '@angular/core';
import { PharmacySegmentListComponent } from '../../../../components/admin-dashboard-component/pharmacy-segments-component/pharmacy-segment-list-component/pharmacy-segment-list-component';

@Component({
  selector: 'app-pharmacy-segment-list-page',
  standalone: true,
  imports: [PharmacySegmentListComponent],
  templateUrl: './pharmacy-segment-list.html',
})
export class PharmacySegmentList {}